module.exports = __webpack_public_path__ + "img/chart.adf0635d.png";